import { render } from "./docs.vue?vue&type=template&id=105b132c&scoped=true"
import script from "./docs.vue?vue&type=script&lang=js"
export * from "./docs.vue?vue&type=script&lang=js"

import "./docs.vue?vue&type=style&index=0&id=105b132c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-105b132c"]])

export default __exports__